/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_PreferencesInputs */

const en_save_preferences = /** @type {(inputs: Save_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Preferences`)
};

const es_save_preferences = /** @type {(inputs: Save_PreferencesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar preferencias`)
};

/**
* | output |
* | --- |
* | "Save Preferences" |
*
* @param {Save_PreferencesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const save_preferences = /** @type {((inputs?: Save_PreferencesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_PreferencesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_save_preferences(inputs)
	return es_save_preferences(inputs)
});